// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".import-model-file-dialog-path[data-v-83dc82f8] {\n  color: #969696;\n}", ""]);
// Exports
module.exports = exports;
